import { useMemo } from "react";
import { useDispatch } from "react-redux";
var MAS_LIMITE = "MAS_LIMITE";
export var useDataPerson = function (responsePerson, responseGetCatalog) {
    var _a;
    var person = Array.isArray(responsePerson)
        ? responsePerson[0]
        : responsePerson;
    var dispatch = useDispatch();
    var birthDate = useMemo(function () {
        var _a;
        return (_a = person === null || person === void 0 ? void 0 : person.dob) !== null && _a !== void 0 ? _a : "";
    }, [person === null || person === void 0 ? void 0 : person.dob]);
    var gender = useMemo(function () {
        var _a;
        if (!(person === null || person === void 0 ? void 0 : person.catalogGender) || !responseGetCatalog)
            return "";
        var found = responseGetCatalog.find(function (item) { return item.id === person.catalogGender; });
        return (_a = found === null || found === void 0 ? void 0 : found.code) !== null && _a !== void 0 ? _a : "";
    }, [person === null || person === void 0 ? void 0 : person.catalogGender, responseGetCatalog]);
    var creditCardList = useMemo(function () {
        var _a, _b;
        var accounts = (_b = (_a = person === null || person === void 0 ? void 0 : person.additionalContentMap) === null || _a === void 0 ? void 0 : _a.accounts) !== null && _b !== void 0 ? _b : [];
        return accounts
            .filter(function (account) { return account.category === MAS_LIMITE; })
            .map(function (account, index) {
            var lastFour = account.number.slice(-4);
            return {
                id: String(index + 1),
                name: "************".concat(lastFour),
                value: lastFour,
                metaData: {
                    montoAprobado: account.approvedAmount
                        ? String(account.approvedAmount)
                        : "0",
                },
            };
        });
    }, [(_a = person === null || person === void 0 ? void 0 : person.additionalContentMap) === null || _a === void 0 ? void 0 : _a.accounts]);
    return { birthDate: birthDate, gender: gender, creditCardList: creditCardList };
};
